module.exports = __webpack_public_path__ + "basic_view_toolbar_bg.d8527634378e6a22680e.png";


//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/fc0fc15e/0/notifi/notifi-web-site/~/syncfusion-javascript/Content/ej/web/common-images/mediaplayer/basic_view_toolbar_bg.png
// module id = ../../../../syncfusion-javascript/Content/ej/web/common-images/mediaplayer/basic_view_toolbar_bg.png
// module chunks = 2